
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs';
import { WarningModalService } from 'src/app/services/warning-modal/warning-modal.service';
import { OrganisationService } from 'src/app/services/organisation/organisation.service';

@Component({
  selector: 'app-note-to-candidate-and-referee',
  templateUrl: './note-to-candidate-and-referee.component.pug',
  styleUrls: ['./note-to-candidate-and-referee.component.scss'],
  standalone: false
})
export class NoteToCandidateAndRefereeComponent implements OnInit {
    
    // Inputs
    @Input() noteToCandidate: string = '';
    @Input() noteToReferee: string = '';

    // Output
    @Output() noteToCandidateValueChange = new EventEmitter<string>();
    @Output() noteToRefereeValueChange = new EventEmitter<string>();

    createReferenceSurveyFromScratchComponent: BsModalRef = new BsModalRef();

    // Default values
    defaultNoteToCandidate: string = '';
    defaultNoteToReferee: string = '';

    // Character limits
    notesToCandidateCharLimit = 500;
    notesToRefereeCharLimit = 500;

    // Disable revert buttons
    disableCandidateRevert: boolean = true;
    disableRefereeRevert: boolean = true;

    // Revert buttons clicked state
    revertToDefaultCandidateNoteClicked = false;  
    revertToDefaultRefereeNoteClicked = false;
  
    //tooltips
    noteToCandidateTooltip = $localize`This customisable message will appear in the email to the candidate and when they nominate their referees.`
    noteToRefereeTooltip = $localize`This customisable message will appear in the email to the referee and when they provide their feedback.`

    constructor(
          public _bsModalRef: BsModalRef,
          private modal: WarningModalService,
          public modalService: BsModalService,
          public organisationService: OrganisationService,
      ) {
    }
    ngOnInit(): void {
      this.organisationService.getOrganisation().subscribe((orgDetails)=>{
          this.defaultNoteToCandidate = orgDetails?.notes?.note_to_candidate || '';
          this.defaultNoteToReferee = orgDetails?.notes?.note_to_referee || '';
          this.disableCandidateRevert = (this.noteToCandidate.trim() === this.defaultNoteToCandidate);
          this.disableRefereeRevert = (this.noteToReferee.trim() === this.defaultNoteToReferee);
      });
    }
    
    
    onCandidateNoteChange(updatedNotetoCandidate) {
        this.disableCandidateRevert = (updatedNotetoCandidate === this.defaultNoteToCandidate);
        this.noteToCandidate =updatedNotetoCandidate;
        this.noteToCandidateValueChange.emit(this.noteToCandidate);
    }

    canDeactiveRevert(): Observable<boolean> {
        let title = $localize`Revert to default? `;
        let message = $localize`By reverting to the default, all changes will be lost.\n\nAre you sure you want to continue?  `;
        let cancelButton = $localize`Cancel`;
        let agreeButton = $localize`Yes`;
        return this.modal.confirm(title, message, false, cancelButton, agreeButton);
    }

    revertToDefaultCandidateNote() {
        this.canDeactiveRevert().subscribe((canRevert) => {
          if (canRevert) {
          this.noteToCandidate = this.defaultNoteToCandidate;
          this.disableCandidateRevert = (this.noteToCandidate === this.defaultNoteToCandidate);
          this.noteToCandidateValueChange.emit(this.noteToCandidate);
          }
          else{
            this.noteToCandidate = this.noteToCandidate; // keep the current value if revert is not confirmed
          }
       });
    }

    onRefereeNoteChange(updatedNotetoReferee) {
        this.disableRefereeRevert = (updatedNotetoReferee === this.defaultNoteToReferee);
        this.noteToReferee = updatedNotetoReferee;
        this.noteToRefereeValueChange.emit(this.noteToReferee);
    }

    revertToDefaultRefereeNote() {
        this.canDeactiveRevert().subscribe((canRevert) => {
          if (canRevert) {
            this.noteToReferee = this.defaultNoteToReferee;
            this.disableRefereeRevert = (this.noteToReferee === this.defaultNoteToReferee);
            this.noteToRefereeValueChange.emit(this.noteToReferee);
          }
          else {
            this.noteToReferee = this.noteToReferee; // keep the current value if revert is not confirmed
          }
       });
    }
}